<template>
  <div>
    <form @submit.prevent="submitSearchLogs">
      <div class="md-layout form-search my-4">
        <div class="md-layout-item md-size-33 md-small-size-100">
          <md-field>
            <label>{{ $t("setting.type_import") }}</label>
            <md-select
              name="type_import"
              id="type_import"
              v-model="type_import"
            >
              <md-option value="all">{{ $t("common.all") }}</md-option>
              <md-option v-for="type in typeOptions" :key="type" :value="type">
                {{ $t(`setting.${type}`) }}
              </md-option>
            </md-select>
          </md-field>
        </div>
        <div class="md-layout-item md-size-33 md-small-size-100">
          <md-field>
            <label>{{ $t("common.username") }}</label>
            <md-input v-model.trim="username" type="input"> </md-input>
          </md-field>
        </div>
        <div class="md-layout-item">
          <md-button type="submit" class="md-info md-round">
            {{ $t("common.search") }}
          </md-button>
        </div>
      </div>
    </form>

    <md-card>
      <md-card-content v-if="dataTable.length">
        <md-table
          class="paginated-table table-striped table-hover table-bordered"
          v-model="dataTable"
        >
          <md-table-row slot="md-table-row" slot-scope="{ item }">
            <md-table-cell
              :md-label="$t('common.no_number')"
              class="no-number"
              >{{ item.noNumb }}</md-table-cell
            >
            <md-table-cell :md-label="$t('setting.type_import')">{{
              item.type
            }}</md-table-cell>
            <md-table-cell :md-label="$t('setting.creator')">{{
              item.username
            }}</md-table-cell>
            <md-table-cell :md-label="$t('setting.object')">
              {{ item.object }}
              <span
                class="text-warning"
                v-if="item.type === 'Cloned term class'"
                @click="openContext(item.object, item.context)"
              >
                - {{ $t("common.view") }}
              </span>
            </md-table-cell>
            <md-table-cell :md-label="$t('setting.time')">{{
              item.time
            }}</md-table-cell>
          </md-table-row>
        </md-table>

        <md-dialog :md-active.sync="viewDetail">
          <md-dialog-title>{{ objectName }}</md-dialog-title>
          <md-dialog-content>
            <md-table v-if="classList.length">
              <md-table-row
                v-for="(item, index) in classList"
                :key="item + index"
              >
                <md-table-cell>{{ index + 1 }}</md-table-cell>
                <md-table-cell>{{ item }}</md-table-cell>
              </md-table-row>
            </md-table>
            <p v-else>{{ $t("setting.classes_not_exist") }}</p>
          </md-dialog-content>
        </md-dialog>

        <div
          class="flex justify-center my-3"
          v-if="dataTable.length < totalRecords"
        >
          <a class="text-info hover:text-info font-medium" @click="loadMore">
            {{ $t("setting.load_more") }}
          </a>
        </div>
      </md-card-content>

      <md-card-content v-else>
        <no-data-found></no-data-found>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import axios from "axios";
import { initLoader, getCookie } from "../../helpers/utils";
import moment from "moment";
import { mapState } from "vuex";
import KeycloakLib from "@/libs/Keycloak";

export default {
  name: "all-action",
  data() {
    const defaultSchoolId = getCookie("schoolId") || "";
    return {
      scId: defaultSchoolId,
      path: `${process.env.VUE_APP_SIS_LOG}/_search`,
      username: "",
      type_import: "all",
      typeOptions: [
        "import_student",
        "import_staff",
        "import_activity_score",
        "import_sri_smi",
        "import_act",
        "import_sbac",
        "import_physical_performance_measures",
        "import_ielts",
        "import_toefl",
        "import_sat",
        "create_new_student",
        "create_new_class",
        "cloned_class",
        "cloned_term_class"
      ],
      dataTable: [],
      perPage: 10,
      totalRecords: null,
      viewDetail: false,
      objectName: "",
      classList: []
    };
  },
  computed: {
    ...mapState("user", ["info"])
  },
  methods: {
    setQueryParams(type, username, from) {
      const defaultQuery = {
        from: from,
        size: this.perPage, // from same offset, size same limit
        query: {
          bool: {
            must: [
              {
                range: {
                  "when.name": {
                    gte: "now-6M/d", // now minus 6 months
                    lte: "now",
                    format: "yyyy-MM-dd"
                  }
                }
              },
              {
                wildcard: {
                  "who.name": {
                    value: `*${username}*`,
                    case_insensitive: true
                  }
                }
              }
            ],
            should: [
              {
                term: {
                  "where.payload.school_uuid": this.scId
                }
              }
            ]
          }
        },
        sort: [
          {
            "when.payload.timestamp": {
              order: "desc", 
              "unmapped_type" : "date"
            },
            "when.payload.date": {
              order: "desc",
              "unmapped_type" : "date"
            }
          }
        ]
      };

      if (type && type !== "all") {
        defaultQuery.query.bool.must.push({
          term: {
            "what.name": type
          }
        });
      }

      return defaultQuery;
    },

    submitSearchLogs() {
      this.dataTable = [];
      this.generateTable(0);
    },

    generateTable(from) {
      const param = this.setQueryParams(this.type_import, this.username, from);
      this.fetchData(param);
    },

    fetchData(param) {
      let loader = initLoader();
      axios
        .post(this.path, param, {
          headers: {
            Authorization: "Bearer " + KeycloakLib.getToken()
          }
        })
        .then(response => {
          this.totalRecords = response.data.hits.total.value - 1;
          const data = response.data.hits.hits.filter(
            element => element._source.what
          );
          if (data.length) {
            this.dataTable = this.dataTable.concat(
              this.generateTableBody(param.from || 1, data)
            );
          }
        })
        .finally(() => {
          loader.hide();
        });
    },

    generateTableBody(noNumberStart, data) {
      return data.map((item, index) => ({
        noNumb: noNumberStart + index,
        type: this.$t(`setting.${item._source.what.name}`),
        username: item._source.who.name,
        object: this.showInfoObject(item._source.what),
        context: this.getClassList(item._source.what),
        time: this.convertTimestampToDate(item._source.when.payload.timestamp)
      }));
    },

    getClassList(item) {
      return item.name === "cloned_term_class"
        ? item.payload.context.cloned_name
        : [];
    },

    convertTimestampToDate(timestamp) {
      const formatDateClient =
        localStorage.getItem("language") === "en"
          ? "MM-DD-YYYY, hh:mm A"
          : "DD-MM-YYYY, hh:mm A";
      return moment(timestamp * 1000).format(formatDateClient);
    },

    showInfoObject(item) {
      let type = item.name;
      let context = item.payload.context;
      let contextDetail = "";
      if (type.split("_").includes("import")) {
        contextDetail =
          typeof context.file_url === "string"
            ? context.file_url.split("/").pop()
            : "";
      }

      if (type === "create_new_student") {
        contextDetail = `${context.username} - ${
          context.full_name
        } - ${context.student_code || ""}`;
      }

      if (type === "create_new_class") {
        contextDetail = this.$t("setting.event_text_new_class", {
          className: context.class_name,
          subjectName: context.subject_name,
          termName: context.term_name
        });
      }
      if (type === "cloned_class") {
        contextDetail = this.$t("setting.event_text_clone_class_existed", {
          className: context.class_name,
          subjectName: context.subject_name,
          termName: context.term_name
        });
      }

      if (type === "cloned_term_class") {
        contextDetail = this.$t("setting.event_text_clone_class_from_term", {
          oldTermName: context.old_term_name,
          newTermName: context.new_term_name,
          length: context.cloned_name?.length
        });
      }

      return contextDetail;
    },

    openContext(objectName, context) {
      this.viewDetail = true;
      this.objectName = objectName;
      this.classList = context;
    },

    loadMore() {
      this.generateTable(this.dataTable.length + 1);
    }
  },
  created() {
    this.submitSearchLogs();
  }
};
</script>
